import { Profile } from "PFTypes";
import jqXHR = JQuery.jqXHR;
import { ApiRoute } from "PFCore/utilities/routes";

export const toggleUserStatus = (id: string, isActive: boolean): jqXHR<Profile> => {
  const url = isActive
    ? ApiRoute(`/api/admin/users/${id}/suspend`)
    : ApiRoute(`/api/admin/users/${id}/activate`);

  return $.ajax({
    type: "PUT",
    url: url
  });
};
